import React from 'react'
import { useState } from 'react';
import './Dark.css'
import './Themes.css'

function  Dark  () {


  const [backgroundColor, setBackgroundColor] = useState('#000000');
  const [textColor, setTextColor] = useState('#ffffff');
  const [hoverColor, setHoverColor] = useState('#ffffff');
  const [lghtColor, setlghtColor ] = useState('#343541')

  const handleColorChange = (bgColor, textColor , lghtColor ,  hoverColor, whiteColor ,shadowColor , floatnavColor) => {
    setBackgroundColor(bgColor);
    setlghtColor(lghtColor);
    setTextColor(textColor); 
    setHoverColor(hoverColor);
    document.documentElement.style.setProperty('--bg-color', bgColor);   
    document.documentElement.style.setProperty('--color-light', lghtColor);
    document.documentElement.style.setProperty('--text-color', textColor);
    document.documentElement.style.setProperty('--hover-color',hoverColor);
    document.documentElement.style.setProperty('--white-color',whiteColor);
    document.documentElement.style.setProperty('--shadow-color',shadowColor);
    document.documentElement.style.setProperty('--floatnav-color',floatnavColor);
  };


    

    



  return (
    <div className="container background">
      <h4>Background</h4>

          <div className="choose-bg">
            <div className="bg-1" onClick={() => handleColorChange('#EFEFF0','#343541', ' #EFEFF0' ,'','','','#0000004d')} >
              <h4>Light</h4>
    
       </div>
       <div className="bg-2" onClick={() => handleColorChange('#0F0F0F', '#ffffff', '#ffffff','#000000','#000000','#ffffffad','#ffffff17')} >
        <h4>Dark</h4>
                   </div> 
              </div>
            </div>
  )
}

export default Dark
